module.exports = __webpack_public_path__ + "static/media/Networth2.9647990e.png";